var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundStatusBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 68,
    viewBox: "0 0 242 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.978683 59.8504L6.16225 7.73369C6.51815 4.15536 9.74479 1.23369 13.3408 1.23369H235.325C238.856 1.23369 241.41 4.05443 241.06 7.56862L235.876 59.6936L236.706 59.7761L235.876 59.6936C235.52 63.2718 232.294 66.1935 228.697 66.1935H6.7139C4.8658 66.1935 3.37214 65.5286 2.37732 64.4421C1.38401 63.3572 0.826435 61.7843 0.978683 59.8504Z",
    stroke: "#737092",
    strokeWidth: 1.66854
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundStatusBorder);
export default __webpack_public_path__ + "static/media/background-status-border.cd792dabb188834d7073dbb14fa4628e.svg";
export { ForwardRef as ReactComponent };